import { forwardRef } from 'react'

const SIZES = {
  sm: 26,
  md: 32,
  lg: 40,
}

const IconButton = forwardRef(function IconButton(
  {
    children,
    icon = null,
    size = 'md',
    variant = 'ghost',
    disabled = false,
    'aria-label': ariaLabel,
    style: styleOverride,
    ...rest
  },
  ref
) {
  const dim = SIZES[size] || SIZES.md
  const variantStyles =
    variant === 'primary'
      ? {
          background: 'var(--olv-grad-brand)',
          color: 'white',
          border: '1px solid rgba(124,92,252,0.40)',
        }
      : variant === 'danger'
      ? {
          background: 'rgba(255,59,92,0.10)',
          color: 'var(--olv-red)',
          border: '1px solid rgba(255,59,92,0.30)',
        }
      : {
          background: 'transparent',
          color: 'var(--olv-text-secondary)',
          border: '1px solid rgba(255,255,255,0.08)',
        }

  return (
    <button
      ref={ref}
      type="button"
      aria-label={ariaLabel}
      disabled={disabled}
      style={{
        width: dim,
        height: dim,
        borderRadius: 'var(--olv-radius-card)',
        ...variantStyles,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.55 : 1,
        transition: 'opacity 200ms var(--ease-standard)',
        ...styleOverride,
      }}
      {...rest}
    >
      {icon || children}
    </button>
  )
})

export default IconButton
